import { required } from 'vuelidate/lib/validators';

export default {
  findCar: {
    newUsed: { required },
    makeId: { required },
    bodyType: { required },
    modelId: { required },
    transmission: { required },
    year: { required }
  }
};
